import { StatusEnumItem } from './StatusEnumItem'
import { StatusEnum } from './statusEnum'

const Draft = new StatusEnumItem({
  id: 'B15FF5F2-EB29-417D-99DD-6F4629A45A94',
  name: 'Draft',
  description: "The Issue has been created but isn't ready for submittal yet",
  priority: 0,
})

const PendingResponse = new StatusEnumItem({
  id: 'DA3F66A7-5FFF-4CA0-9C9C-C8F7B10A2253',
  name: 'Pending Response',
  description: 'The Issue has been submitted and is waiting for a response',
  priority: 1,
})

const PendingDisposition = new StatusEnumItem({
  id: 'CD78983D-ECFE-4773-8619-F5DA90E8A5F4',
  name: 'Pending Disposition',
  description:
    'The Issue has received a response and is waiting for a disposition type',
  priority: 2,
})

const PendingClosure = new StatusEnumItem({
  id: 'F197A461-5D8C-4C12-A765-9BD8F346FBD8',
  name: 'Pending Closure',
  description:
    'The Issue has receievd a disposition type and is waiting for closure notes',
  priority: 3,
})

const Closed = new StatusEnumItem({
  id: 'E4FF5800-9B1A-4043-827C-7C365D674A95',
  name: 'Closed',
  description:
    'The Issue has completely gone through the Issue Tracker workflow and its associated SharePoint folder is locked. Limited fields are editable',
  priority: 4,
})

const Unlocked = new StatusEnumItem({
  id: 'C8478C92-D40E-41E9-AA4C-D7D8D05019F5',
  name: 'Unlocked',
  description: 'The Issue has been unlocked in CIMS and SharePoint for editing',
  priority: 5,
})

export type IssueStatusItem =
  | typeof Draft
  | typeof PendingResponse
  | typeof PendingDisposition
  | typeof PendingClosure
  | typeof Closed
  | typeof Unlocked
class IssueStatusEnum extends StatusEnum<
  'IssueStatus',
  IssueStatusItem,
  IssueStatusItem['name'],
  IssueStatusItem['id'],
  IssueStatusItem['priority']
> {
  readonly typename = 'IssueStatus' as const
  get values() {
    return [
      this.Draft,
      this.PendingResponse,
      this.PendingDisposition,
      this.PendingClosure,
      this.Closed,
      this.Unlocked,
    ]
  }
  readonly Draft = Draft
  readonly PendingResponse = PendingResponse
  readonly PendingDisposition = PendingDisposition
  readonly PendingClosure = PendingClosure
  readonly Closed = Closed
  readonly Unlocked = Unlocked
}
/**
 * @see {@link IssueStatusEnum}
 * @see {@link IssueStatusItem}
 */
export const IssueStatus = new IssueStatusEnum()
